//baseUrl
const DOMAIN_NAME = {
  // URL_EASYMOCK: 'http://marsbox-app.xueqiusoft.com'
  URL_EASYMOCK: 'https://qingke.imarsbox.com'  // 正式服
  // URL_EASYMOCK: 'http://mars-light.hk'  // 本地
}

export default DOMAIN_NAME



// WEBPACK FOOTER //
// ./src/server/config.js